import React, { FC } from 'react';
import { Box, Typography } from '@material-ui/core';

import { LearnerInfo } from '../../../../types';
import { translate } from '../../../../utils/helpers';
import { CustomButton } from '../../../../components/UI/CustomButton';
import useStyles from './styles';

interface AccountDetailsViewProps {
  userInfo?: LearnerInfo;
  setFormEnabled: Function;
}

const AccountDetailsView: FC<AccountDetailsViewProps> = ({ userInfo, setFormEnabled }) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.info}>
        <Box className={classes.infoCell}>
          <Typography className={classes.infoLabel}>
            {translate('page.account.firstName')}
          </Typography>
          <span>{userInfo?.first_name}</span>
        </Box>
        <Box className={classes.infoCell}>
          <Typography className={classes.infoLabel}>
            {translate('page.account.lastName')}
          </Typography>
          <span>{userInfo?.last_name}</span>
        </Box>
        <Box className={classes.infoCell}>
          <Typography className={classes.infoLabel}>
            {translate('page.account.jobTitle')}
          </Typography>
          <span>{userInfo?.job ? userInfo?.job : '-'}</span>
        </Box>
        <Box className={classes.infoCell}>
          <Typography className={classes.infoLabel}>
            {translate('page.account.areasOfInterest')}
          </Typography>
          {userInfo?.interests?.length
            ? userInfo?.interests?.map((int) => (
                <span key={int?.id} className={classes.interestItem}>
                  {int?.title}
                </span>
              ))
            : '-'}
        </Box>
      </Box>
      <CustomButton id="edit-btn" btnClass={classes.btn} onClick={() => setFormEnabled(true)}>
        {translate('button.edit')}
      </CustomButton>
    </Box>
  );
};

export default AccountDetailsView;
